import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/hooks/api/models';

/**
 * 2080. ダッシュボード（月次分析）
 * [GET] /workspaces/:identifier/dashboard/monthly_analysis
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  product_ids?: number[];
  sales_context_ids?: number[];
};

export type DashboardMonthlyAnalysis = {
  target_year_month: number[];
  sales_target_cumulative_amounts: number[];
  attack_list_cumulative_amounts: number[];
  initial_proposal_cumulative_amounts: number[];
  detail_proposal_cumulative_amounts: number[];
  under_negotiation_cumulative_amounts: number[];
  contracting_cumulative_amounts: number[];
  completed_cumulative_amounts: number[];
  sales_target_amounts: number[];
  attack_list_amounts: number[];
  initial_proposal_amounts: number[];
  detail_proposal_amounts: number[];
  under_negotiation_amounts: number[];
  contracting_amounts: number[];
  completed_amounts: number[];
  sales_order_phase_labels: {
    attack_list: string;
    initial_proposal: string;
    detail_proposal: string;
    under_negotiation: string;
    contracting: string;
    lost_order: string;
    pending: string;
    completed: string;
  };
};
const dashboardMonthlyAnalysis = (props: Props): Promise<DashboardMonthlyAnalysis> => {
  return axios.get(`/api/workspaces/${props.identifier}/dashboard/monthly_analysis`, { params: props });
};

export const useDashboardMonthlyAnalysis = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'dashboard', 'monthly_analysis', { ...props }],
    queryFn: () => dashboardMonthlyAnalysis(props),
    staleTime: 1000 * 60 * 30,
  });
};
